import { useState } from 'react';

import { SuggestionItemProps } from '../../Suggestion.types';

type ThumbnailStates = 'loader' | 'fallBack' | 'image' | 'none';

export function useItemThumbnail(item: SuggestionItemProps['item']) {
  const [thumbnailState, setThumbnailState] = useState<ThumbnailStates>(
    getInitialState(item.image),
  );

  const onError = () => setThumbnailState('fallBack');
  const onLoad = () => setThumbnailState('image');

  return { onError, onLoad, thumbnailState };
}

function getInitialState(
  image: SuggestionItemProps['item']['image'],
): ThumbnailStates {
  if (typeof image === 'undefined') {
    return 'none';
  }
  return image?.name ? 'loader' : 'fallBack';
}
